var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"ink",on:{"click":_vm.click}},[_vm._v("\n\t"+_vm._s(_vm.manufacturer)+"\n\t"),_c('br'),_vm._v("\n\t"+_vm._s(_vm.name)+"\n\t"),(_vm.new_description)?_c('span',[_vm._v("(*)")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":_vm.file}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f01d07c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ink.vue
// module id = null
// module chunks = 